// extracted by mini-css-extract-plugin
export default {"BtnClose":"Style_BtnClose__T7hS-","popup":"Style_popup__tAotW","circled":"Style_circled__Zhai5"};